import React, { Component } from 'react';
import radium, { Style } from 'radium';
import SideMenuSlider from '../../../../../../../components/SideMenuSlider';
import FlashCardSettings from './FlashCardSettings';
import AccordionSettings from './AccordionSettings';
import ImageSettings from './ImageSettings';
import VideoSettings from './VideoSettings';
import AudioSettings from './AudioSettings';
import EmbedSettings from './EmbedSettings';
import AttachmentSettings from './AttachmentSettings';

class SettingsMenu extends Component {
  static styles = {};

  getSettingsComponent = (blockItem) => {
    const props = {
      blockItem,
      cardId: this.props.cardId,
      courseId: this.props.courseId,
      showRaw: this.state.showRaw
    };
    switch (blockItem.type) {
      case 'interactive':
        if (blockItem.variant === 'flashcardStack' || blockItem.variant === 'flashcardGrid') {
          return <FlashCardSettings {...props} />;
        }
        if (blockItem.variant === 'accordion' || blockItem.variant === 'tabs') {
          // console.log(props);
          return <AccordionSettings {...props} />;
        }
        return null;
      case 'image':
      case 'quote':
        return <ImageSettings {...props} />;
      case 'multimedia': {
        if (blockItem.variant === 'video') {
          return <VideoSettings {...props} />;
        }
        if (blockItem.variant === 'audio') {
          return <AudioSettings {...props} />;
        }
        if (blockItem.variant === 'embed') {
          return <EmbedSettings {...props} />;
        }
        if (blockItem.variant === 'attachment') {
          return <AttachmentSettings {...props} />;
        }
        return null;
      }
      default:
        return null;
    }
  };

  getTypeTitle = ({ type, family, variant }) => {
    switch (type) {
      case 'interactive': {
        if (family === 'interactive') {
          if (variant === 'flashcardStack') return '';
          if (variant === 'flashcardGrid') return '';
          if (variant === 'accordion') return '';
        }
        return 'Interactive';
      }
      case 'knowledge': {
        return 'Edit Quiz';
      }
      case 'image': {
        return 'Image settings';
      }
      case 'multimedia': {
        if (variant === 'video') return 'Video settings';
        if (variant === 'audio') return 'Audio settings';
        if (variant === 'embed') return 'Embed settings';
        return 'Multimedia';
      }
      default:
        return 'Default Title';
    }
  };

  render() {
    const styles = SettingsMenu.styles;
    const { openMenu, blockItem, closeSideMenu } = this.props;
    return (
      <SideMenuSlider side="right" open={openMenu} closeSideMenu={closeSideMenu}>
        {blockItem && (
          <span className="blocks-sidebar__heading">{this.getTypeTitle(blockItem)}</span>
        )}
        {openMenu && blockItem && this.getSettingsComponent(blockItem)}
        <Style rules={styles.classBased} scopeSelector=".SettingsMenuContainer" />
      </SideMenuSlider>
    );
  }
}

export default radium(SettingsMenu);
